import { useEffect, useState } from 'react';

type ElementSize = {
  width: number;
  height: number;
};

// Tracks element dimensions in real-time using ResizeObserver API
// Needed for responsive gallery components that adjust layout based on container size (e.g., ScrollBar positioning, carousel calculations)

export default function useElementSize<T extends HTMLElement>(
  ref: React.RefObject<T | null>
): ElementSize {
  const [size, setSize] = useState<ElementSize>({ width: 0, height: 0 });

  useEffect(() => {
    const element = ref.current;

    if (!element) return;

    const observer = new ResizeObserver(([entry]) => {
      setSize({
        width: entry.contentRect.width,
        height: entry.contentRect.height
      });
    });

    observer.observe(element);

    return () => observer.disconnect();
  }, [ref]);

  return size;
}
